function resetScroll() {
  // 1) window / document
  window.scrollTo({ top: 0, left: 0, behavior: "instant" as ScrollBehavior });
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;

  // 2) koi bhi wrapper jo scrolled ho
  document.querySelectorAll<HTMLElement>("*").forEach((el) => {
    if (el.scrollTop > 0) el.scrollTop = 0;
  });
}

function resetScrollAfterRender() {
  // Turant, phir render ke baad dobara (React content baad mein paint karta hai)
  resetScroll();
  requestAnimationFrame(() => {
    resetScroll();
    setTimeout(resetScroll, 50);
  });
}

let installed = false;

export function installScrollOnNavigate() {
  if (installed || typeof window === "undefined") return;
  installed = true;

  // Browser ko apna scroll restore karne se rokein
  if ("scrollRestoration" in history) {
    history.scrollRestoration = "manual";
  }

  const fire = () => window.dispatchEvent(new Event("app:locationchange"));

  const origPush = history.pushState;
  const origReplace = history.replaceState;

  history.pushState = function (...args) {
    const before = location.href;
    const ret = origPush.apply(this, args as any);
    if (location.href !== before) fire();
    return ret;
  };

  history.replaceState = function (...args) {
    const before = location.href;
    const ret = origReplace.apply(this, args as any);
    if (location.href !== before) fire();
    return ret;
  };

  window.addEventListener("popstate", fire); // browser back/forward
  window.addEventListener("app:locationchange", resetScrollAfterRender);
}